// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// *************************************************************** position *****************************************************************
const GET_POSITIONS_PERMISSION_TINY_SUCCESS = 'GET_POSITIONS_PERMISSION_TINY_SUCCESS';
// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// *************************************************************** position *****************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _getPositionsPermissionSuccess(payload) {
  return {
    type: GET_POSITIONS_PERMISSION_TINY_SUCCESS,
    payload: payload,
  };
}


// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// *************************************************************** position *****************************************************************
/**
 *
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function getPositions(params = {}, callback = () => {
}) {
  return (dispatch, gs, api) => {
    api.get(`/positions`, {params})
      .then((res) => {
        dispatch(_getPositionsPermissionSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        callback(err);
      });
  };
}
// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(state = {
  positions: [],
  meta: {},
}, action) {
  switch (action.type) {
    case GET_POSITIONS_PERMISSION_TINY_SUCCESS:
      return Object.assign({}, state, {
        positions: action.payload.data.positions,
        meta: action.payload.meta,
      });
    default:
      return state;
  }
}
